<template lang="html">
	<div class="subject" :style="{backgroundImage: 'url('+ detailsIist.background +')'}">
		<!-- 答题卡 -->
		<div class="swiper-container">
			<div class="swiper-wrapper">
				<div class="swiper-slide" v-for="(a, index) in topic" :key="index">
					<!-- 单选 -->
					<div class="" v-if="a.type === 'single_choice'">
						<SingleChoice v-bind:singlechoice="a" v-bind:allTopic="topic.length" @toFatherData="sendSonData" />
					</div>
					<!-- 多选 -->
					<div class="" v-if="a.type === 'choice'">
						<MultipleChoice v-bind:multiplechoice="a" v-bind:allTopic="topic.length" />
					</div>
					<!-- 判断 -->
					<div class="" v-if="a.type === 'determine'">
						<TrueOrFalseQuestions v-bind:judge="a" v-bind:allTopic="topic.length" />
					</div>
					<div class="indicate" v-if="a.seq == '1'">
						<img src="../../assets/image/exam/right.png" alt="">
					</div>
					<div class="indicate" v-if="a.seq == '2'">
						<img src="../../assets/image/exam/double.png" alt="">
					</div>
					<div class="putinBtn" v-if="a.seq == topic.length" @click="putInBtn">
						<div class="putin">
							提交
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 遮罩层 -->
		<div class="shade" v-show="shadeShow">
			<div class="shade_con">
				<img src="../../assets/image/exam/alert.png" alt="" class="shade_icon">
				<div class="shade_text">
					你还没有答完所有题目哦，现在关闭将会失去本次成绩
				</div>
				<div class="shade_btn">
					<div class="quit_btn" @click="quitBtn">
						下次再来
					</div>
					<div class="continue_btn" @click="continueBtn">
						继续答题
					</div>
				</div>
			</div>
		</div>

		<div class="shadeImg" v-show="imgShow">
			<Img v-bind:images="lookImg" ref="imgmodel" />
		</div>
	</div>
</template>

<script>
	import utils from '@/utils/utils.js';
	import Swiper from 'swiper/swiper-bundle.min.js'
	import 'swiper/swiper-bundle.min.css'

	import SingleChoice from './type/SingleChoice'
	import MultipleChoice from './type/MultipleChoice'
	import TrueOrFalseQuestions from './type/TrueOrFalseQuestions'
	import Img from './else/Img.vue'
	export default {
		data() {
			return {
				detailsIist: '',
				topic: [],
				data: {},
				finish: [],
				shadeShow: false,
				imgShow: false,
				lookImg: [],
				swiperIndex: 0,
			}
		},
		components: {
			SingleChoice,
			MultipleChoice,
			TrueOrFalseQuestions,
			Img,
		},
		created() {
			this.getTestQuestions();
		},
		mounted() {
			this.init();
			this.pushHistory();
			window.addEventListener("popstate", () => {
				this.shadeShow = true;
			}, false);
			document.addEventListener("visibilitychange", this.handlePagehide, false);
		},
		methods: {
			init() {
				this.details();
			},
			handlePagehide() {
				if (document.visibilityState == 'hidden') {
					console.log('页面变为不可见时触发');
				} else {
					console.log('页面变为可见时触发');
				}
			},
			// 获取测试须知内容  试卷title
			details() {
				this.$http({
					url: '/paper/getPaperAuthType',
					method: 'get',
					params: {
						task_id: this.$route.query.task_id,
					},
				}).then((res) => {
					if (res.code >= 0) {
						this.$nextTick(function() {
							this.title = res.data.title;
						}, 0);
						this.detailsIist = res.data;
					}
				})
			},

			pushHistory() {
				var state = {
					task_id: this.$route.query.task_id,
					test_id: this.$route.query.test_id,
					user_unique_id: this.$route.query.phone,
					auth_code: this.$route.query.auth_code,
					name: this.$route.query.name,
				};
				window.history.pushState(state, "title", window.location.href);
			},

			good() {
				var Swiper1 = new Swiper('.swiper-container', {
					observer: true,
					observeParents: true,
					watchSlidesProgress: true,
					on: {
						slideChangeTransitionStart: function() {
							this.swiperIndex = this.activeIndex;
							localStorage.setItem('index', this.swiperIndex);
						},
					},
				});
				Swiper1.slideTo(localStorage.getItem('index'), 1);
			},
			// 获取试题
			getTestQuestions() {
				this.$http({
					url: "/paper/items",
					method: 'get',
					params: {
						task_id: this.$route.query.task_id,
						test_id: this.$route.query.test_id,
						user_unique_id: this.$route.query.phone,
						auth_code: this.$route.query.auth_code,
						name: this.$route.query.name,
					},
				}).then((res) => {
					localStorage.setItem('data', res);
					this.topic = res.data;
					this.$nextTick(function() {
						this.good(res.data);
					}, 0);
					this.dataInfo();
				})
			},
			dataInfo() {
				for (var a = 0; a < this.topic.length; a++) {
					this.data[this.topic[a].question_id] = [];
				}
			},

			fatherMethod(id, str) {
				this.data[id] = str;
			},

			noneImg(a) {
				this.imgShow = a;
			},

			sendSonData(data) {
				this.$refs.imgmodel.show(data);
				if (data != '') {
					this.imgShow = true;
				}
			},

			quitBtn() {
				this.$http({
					url: "/paper/doTest",
					method: 'POST',
					params: {
						task_id: this.$route.query.task_id,
						action: 'finish',
						data: this.data,
						test_id: this.$route.query.test_id,
						user_unique_id: this.$route.query.phone,
						auth_code: this.$route.query.auth_code,
						name: this.$route.query.name,
					},
				}).then(() => {
					this.$router.replace({
						path: '/exam',
						query: {
							task_id: this.$route.query.task_id,
						}
					})
					localStorage.setItem('index', '0');
				})
			},
			continueBtn() {
				this.shadeShow = false;
			},

			// 提交按钮
			putInBtn() {
				this.$http({
					url: "/paper/doTest",
					method: 'POST',
					params: {
						task_id: this.$route.query.task_id,
						action: 'finish',
						data: this.data,
						test_id: this.$route.query.test_id,
						user_unique_id: this.$route.query.phone,
						auth_code: this.$route.query.auth_code,
						name: this.$route.query.name,
					},
				}).then((res) => {
					if (res.code >= 0) {
						this.$router.replace({
							path: '/examSucceed',
							query: {
								task_id: this.$route.query.task_id,
								test_id: this.$route.query.test_id,
								phone: this.$route.query.phone,
								auth_code: this.$route.query.auth_code,
								name: this.$route.query.name,
							}
						})
						localStorage.setItem('index', '0');
					} else {
						utils.showMessage(res.msg);
					}
				})
			}
		}
	}
</script>

<style lang="css" scoped>
	.subject {
		position: relative;
		margin: auto;
		width: 100%;
		height: 100%;
		background-size: 100%;
		background-repeat: no-repeat;
		overflow: auto;
		box-sizing: border-box;
	}

	.swiper-slide {
		box-sizing: border-box;
		padding: 0 1.5rem;
	}

	.indicate {
		width: 100%;
		display: flex;
		justify-content: center;
	}

	.indicate img {
		margin-top: .8rem;
		width: 9.3rem;
		height: 9.3rem;
	}

	.putinBtn {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}

	.putin {
		margin-top: 2rem;
		text-align: center;
		width: 21.25rem;
		height: 5rem;
		line-height: 5rem;
		border-radius: 5rem;
		background: linear-gradient(#FFFFFF, #04DDAB);
		font-size: 2.8rem;
		font-weight: 600;
		color: #120A46;
	}

	.shade {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.65);
		z-index: 10;
	}

	.shade_con {
		box-sizing: border-box;
		width: 28rem;
		height: 20rem;
		background-color: #FFF;
		position: absolute;
		top: 50%;
		left: 50%;
		margin-top: -10rem;
		margin-left: -14rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 0 1.5rem;
		border-radius: 1.5rem;
	}

	.shade_icon {
		width: 9rem;
		margin-top: -6rem;
	}

	.shade_text {
		font-size: 1.6rem;
		color: #1D2023;
		text-align: center;
		margin-top: 2.4rem;
	}

	.shade_btn {
		width: 100%;
		display: flex;
		justify-content: space-between;
		margin-top: 2.4rem;
	}

	.quit_btn {
		background-color: #E1E4EB;
		width: 12rem;
		height: 4.4rem;
		line-height: 4.4rem;
		border-radius: 4.4rem;
		text-align: center;
		font-size: 1.6rem;
		color: #606972;
	}

	.continue_btn {
		background: linear-gradient(#8053D9, #4929B1);
		width: 12rem;
		height: 4.4rem;
		line-height: 4.4rem;
		border-radius: 4.4rem;
		text-align: center;
		font-size: 1.6rem;
		color: #FFFFFF;
	}

	.shadeImg {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
		background-color: #000;
		z-index: 10;
	}
</style>
